var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7L6 17H14L16 7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H18",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7V4C7 2.89543 7.89543 2 9 2H11C12.1046 2 13 2.89543 13 4V7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketIcon);
export default __webpack_public_path__ + "static/media/BasketIcon.27419bf3a2216427b73cc9cf599bcef5.svg";
export { ForwardRef as ReactComponent };